import { useGetUser } from '@sib/api';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Skeleton,
  UserAvatar,
} from '@sib/ui';
import { ChevronDown } from '@sib/ui/icons';
import { useMenuItems } from './UserMenu.utils';

export const UserMenu = () => {
  const { data: user, isFetching, isLoading } = useGetUser();
  const menuItems = useMenuItems();

  const showLoader = isLoading || isFetching;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex cursor-pointer items-center gap-2">
          {showLoader ? (
            <>
              <Skeleton className="size-8.75 rounded-full" />
              <Skeleton className="h-5 w-40 rounded-md" />
            </>
          ) : (
            <>
              <UserAvatar
                variant="small"
                avatarImageProps={{
                  avatarUrl: user?.avatarUrl || '',
                }}
                avatarFallbackProps={{ name: user?.name }}
                className="size-8.75"
              />
              <p className="text-primary text-base leading-5 font-medium">
                {user?.name}
              </p>
            </>
          )}
          <ChevronDown />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="end">
        {menuItems.map(item => (
          <DropdownMenuItem key={item.label} onClick={item.action}>
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
